<template>
  <div class="wrapper">
    <div class="function-button">
      <div class="function-item" @click="jumpTo('/message/unsend')">
        <p class="title">待寄送({{unSendTicketCount}})</p>
        <section>
          <div class="left">
            <p>报帐发票</p>
            <span class="iconfont">&#xe648;</span>
          </div>
          <span class="iconfont right-icon">&#xe6df;</span>
        </section>
      </div>
      <div class="function-item right" @click="jumpTo('/message/unreceive')">
        <p class="title">待签收({{unSignedTicketCount}})</p>
        <section>
          <div class="left">
            <p>报帐发票</p>
            <span class="iconfont">&#xe648;</span>
          </div>
          <span class="iconfont right-icon">&#xe6de;</span>
        </section>
      </div>
    </div>
    <div class="pull-list">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-swipe-cell
            v-for="(item, index) in dataSource"
            :key="index"
            :name="index"
            :disabled="true"
            :before-close="beforeClose"
          >
            <div class="message-wrp" @click="onClickMessage(item)">
              <p class="content" v-if="item.type === 1">{{item.content}}  <span class="click-to-do">快去完善个人信息吧～</span></p>
              <p class="content" v-else>{{item.content}}  <span class="click-to-do">点此消息查看</span></p>

            </div>
          </van-swipe-cell>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import {
  List,
  PullRefresh,
  Notify,
  SwipeCell
} from 'vant'
import { messageRequest, invoiceRequest } from '@services'
import { onCount } from '@utils/basicUtil'
export default {
  components: {
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [SwipeCell.name]: SwipeCell
  },
  props: {},
  data () {
    return {
      dataSource: [],
      refreshing: false,
      loading: false,
      finished: false,
      searchParams: {
        size: 25,
        current: 1
      },
      unSendTicketCount: 0,
      unSignedTicketCount: 0
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.getTicketLogistics()
    this.getDataList()
  },
  activated () {},
  updated () {},
  methods: {
    async getTicketLogistics () {
      const data = await messageRequest.todo.getTicketLogistics({})
      if (data.success) {
        this.unSendTicketCount = data.result.unSendTicketIds ? data.result.unSendTicketIds.length : 0
        this.unSignedTicketCount = data.result.unSignedTicketIds ? data.result.unSignedTicketIds.length : 0
      }
    },
    async getDataList () {
      if (this.refreshing) {
        this.refreshing = false
      }
      this.loading = true
      const postData = {
        ...this.searchParams
      }
      const data = await messageRequest.todo.getTodoList(postData)
      if (data.success) {
        if (data.result.records) {
          this.dataSource = [...this.dataSource, ...data.result.records]
          if (Number(data.result.size) > data.result.records.length) {
            this.finished = true
          } else {
            this.finished = false
          }
        } else {
          this.finished = true
        }
      } else {
        this.finished = true
        Notify({ type: 'danger', message: data.message })
      }

      this.loading = false
    },
    onRefresh () {
      this.finished = false
      this.searchParams.current = 1
      this.dataSource = []
      this.getDataList()
    },
    onLoad () {
      this.searchParams.current++
      this.getDataList()
    },
    async onClickMessage (data) {
      let { type, url, attachment, id } = data
      this.changeTodoStatus(id)
      if (type === 1) { // 完善用户信息
        this.$router.push(url)
      } else if (type === 2) { // 开票失败信息
        let data = JSON.parse(attachment)
        await this.getApplyDetail(data.settlementId, true)
        this.$router.push(url)
      } else if (type === 3) {
        this.$router.push(url)
      }
    },
    async changeTodoStatus (id) {
      await messageRequest.todo.updateById({
        id,
        handleFlag: 1
      })
    },
    getApplyDetail (id, changeInfo) {
      return new Promise(async (resolve, reject) => {
        if (!id) {
          resolve(true)
          return
        }
        const data = await invoiceRequest.apply.getApplyDetail({
          id
        })
        if (data.success) {
          let money = 0
          data.result.details.forEach(element => {
            money = onCount.add(money, element.amountWithTax)
          })
          this.files = data.result.files.map(file => {
            return {
              url: file
            }
          })
          const res = {
            ...data.result,
            files: [...this.files],
            invoiceType: String(data.result.invoiceType),
            logisticsFlag: String(data.result.logisticsFlag),
            money: String(money)
          }
          this.receiverInfo = {
            receiverName: data.result.receiverName,
            receiverAddress: data.result.receiverAddress,
            receiverPhone: data.result.receiverPhone,
            receiverEmail: data.result.receiverEmail,
            logisticsFlag: String(data.result.logisticsFlag)
          }
          if (changeInfo) {
            this.$store.commit('invoice/changeApplyData', {
              formData: res
            })
          }
          const goodsList = data.result.details.map(goods => {
            return {
              ...goods,
              price: goods.unitPrice === 0 ? null : goods.unitPrice,
              quantity: goods.quantity === 0 ? null : goods.quantity
            }
          })
          if (changeInfo) {
            this.$store.commit('invoice/changeGoodsList', goodsList)
          }
        } else {
          this.$store.commit('invoice/initApplyData')
          Notify({ type: 'danger', message: data.message })
        }
        resolve(true)
      })
    },
    beforeClose ({ position, instance }) {
      switch (position) {
        case 'left':
          break
      }
    },
    jumpTo (url) {
      this.$router.push(url)
    }
  }
}
</script>
<style scoped lang='less'>
.wrapper{
  padding: 0 30px;
  box-sizing: border-box;
  .function-button{
    display: flex;
    margin: 0 -10px;
    padding-top: 30px;
    .function-item{
      width: 50%;
      background: #F1F4FF;
      box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
      padding: 20px;
      box-sizing: border-box;
      margin: 0 10px;
      .title{
        font-size: 28px;
        font-family: 'PingFang SC';
        font-weight: bold;
        color: #000;
      }
      section{
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        .left{
          p{
            color: #999;
            font-size: 24px;
            font-family: 'PingFang SC';
            font-weight: 400;
            line-height: 34px;
          }
          .iconfont{
            margin-top: 13px;
            display: block;
            width: 31px;
            height: 31px;
            border-radius: 50%;
            background: #B0D5F9;
            color: #fff;
            line-height: 31px;
            text-align: center;
            font-size: 10px;
          }
        }
        .right-icon{
          color: #2372FF;
          opacity: .5;
          font-size: 57px;
        }
      }
    }
    .right{
      background: #FFFAE9;
      section{
        .left{
          .iconfont{
            background: #FCE4A5;
            color: #fff;
          }
        }
        .right-icon{
          color: #FBC636;
        }
      }
    }
  }
  .pull-list{
    .message-wrp{
      background: #fff;
      border-radius: 8px;
      padding: 34px 20px;
      margin-top: 20px;
      .content{
        color: #333;
        font-size: 24px;
        font-family: 'PingFang SC';
        .click-to-do{
          color: #2372FF;
          font-size: 24px;
          font-family: 'PingFang SC';
        }
      }

    }
  }
}
</style>
